import React from 'react'

import { useHistory } from '@ztechapps/common.hook'
import type { Product } from '@ztechapps/common.contract'
import type { BusyButtonProps } from '@ztechapps/webui.button'
import { BusyButton } from '@ztechapps/webui.button'
import { useTrackEvent } from '@ztechapps/webui.telemetry'

import { routesDef } from '../../config/routes'

export type MoreInfoButtonProps = {
  product: Pick<Product, '_id' | 'code'>
} & BusyButtonProps

export const MoreInfoButton = ({ product, ...rest }: MoreInfoButtonProps) => {
  const trackEvent = useTrackEvent()
  const history = useHistory()

  const onClick = () => {
    trackEvent('More Info Button', { product_code: product.code })
    history.push(routesDef.ProductItemPage.altPath({ _id: product._id }))
  }

  return <BusyButton onClick={onClick} icon="arrow-right" text="More info" {...rest} />
}
